import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Drawer, Switch } from 'antd';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import * as downtimeActions from '../../../../../data/redux/downtime_details/actions';

import { APP_PAGES } from '../../../../../data/config/constants';
import { formatDate, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import ShowMessage from '../../../../../components/showmessage';
import CustomHeader from '../../../../../components/customheader';
import ErrorBoundary from '../../../../../components/errorboundary';
import ModalFooter from '../../../../../components/modalfooter';
import ProfileAvatar from '../../../../../components/profileavatar';
import TableCellAction from '../../../components/tablecellaction';
import DowntimeForm from './downtimeform';

class Downtime extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      drawer_data: {
        title: "",
        selected_downtime: null,
        show_create_downtime: false,
        show_edit_downtime: false,
      },
    };
    this.columns = this.getDowntimeTableColumns();
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.pageChanged(APP_PAGES.DOWNTIME, APP_PAGES.SETTINGS);
    actions.fetchDowntimeList();
  }

  getDowntimeTableColumns = () => {
    const columns = [
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return (
            <ProfileAvatar container_class="ori-flex-ac" title={record.type} title_class="ori-font-sm ori-font-bold" avatar_bg_class={{ "ori-bg-primary": true }} default_avatar_bg={!record.active} />
          );
        }
      },
      {
        title: 'Reason',
        dataIndex: 'reason',
        key: 'reason',
        align: 'center'
      },
      {
        title: 'Start time',
        dataIndex: 'start',
        key: 'start',
        align: 'center',
        render: (startDate) => (
          <span className="ori-font-bold ori-font-sm">{formatDate(startDate, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
        )
      },
      {
        title: 'End time',
        dataIndex: 'end',
        key: 'end',
        align: 'center',
        render: (endDate) => (
          <span className="ori-font-bold ori-font-sm">{formatDate(endDate, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
        )
      },
      {
        title: 'Active',
        dataIndex: 'active',
        key: 'active',
        render: (text, record) => (
          <div className="ori-lr-pad-5">
            <Switch size="small" checked={record.active} onChange={(bool) => this.changeDowntimeStatus(bool, record)} />
          </div>
        )
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (text, record) => (
          <TableCellAction align_center show_edit handleEditClick={() => this.showEditDowntime(record)} />
        )
      },
    ];
    return columns;
  }

  closeDrawer = () => {
    this.setState({
      drawer_data: {
        title: "",
        selected_downtime: null,
        show_edit_downtime: false,
        show_create_downtime: false,
      }
    });
  }

  showCreateDowntime = () => {
    this.setState({
      drawer_data: {
        title: "Create New Downtime",
        show_create_downtime: true,
        show_edit_downtime: false,
      }
    });
  }

  showEditDowntime = selected_downtime => {
    this.setState({
      drawer_data: {
        selected_downtime,
        title: "Edit Downtime",
        show_create_downtime: false,
        show_edit_downtime: true,
      }
    });
  }

  onChangeSelectedDowntime = data => {
    this.setState({
      drawer_data: {
        ...this.state.drawer_data,
        selected_downtime: {
          ...this.state.drawer_data.selected_downtime,
          ...data
        }
      }
    });
  }

  changeDowntimeStatus = (active, downtime) => {
    if (downtime && downtime._id) {
      const payload = { ...downtime, active };
      this.props.actions.updateDowntime(payload);
    } else {
      showMessage('warning', 'user email/id is missing.');
    }
  };

  createAndUpdateDowntime = () => {
    const { drawer_data } = this.state;
    if (drawer_data.show_create_downtime && drawer_data.selected_downtime) {
      this.props.actions.createDowntime(drawer_data.selected_downtime, this.closeDrawer)
    } else if (drawer_data.show_edit_downtime && drawer_data.selected_downtime) {
      this.props.actions.updateDowntime(drawer_data.selected_downtime, this.closeDrawer)
    }
  }

  render() {
    const { downtime_list, loaders } = this.props.downtime_details;
    const { screen_width } = this.props;
    const { drawer_data } = this.state;
    if (loaders.downtime_loading && !loaders.downtime_loaded) {
      return (
        <div className="ori-lr-pad-15">
          <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
          <CardRowTableLoader />
        </div>
      );
    } else if (!loaders.downtime_loading && loaders.downtime_loaded) {
      return (
        <div className="ori-lr-pad-15">
          <CustomHeader title="Downtime" first_button_type="primary" first_button_text="+ Add Downtime" onClickFirstButton={this.showCreateDowntime} bottom_bordered show_first_button />
          <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={screen_width < 768 ? "small" : "middle"} columns={this.columns} dataSource={downtime_list} />
          <Drawer className="ori-drawer ori-drawer-title-primary ori-drawer-footer-pad ori-drawer-height-without-footer" width={screen_width < 480 ? screen_width : 460} title={drawer_data.title} visible={drawer_data.show_create_downtime || drawer_data.show_edit_downtime} placement="right" maskClosable={false} onClose={this.closeDrawer}>
            {
              (drawer_data.show_create_downtime || drawer_data.show_edit_downtime) &&
              <ErrorBoundary onErrorCallback={this.closeDrawer}>
                <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden">
                  <DowntimeForm downtime={drawer_data.selected_downtime} onChange={this.onChangeSelectedDowntime} />
                  <div className="ori-absolute ori-full-width ori-align-bottom ori-align-left ori-b-pad-5">
                    <ModalFooter button_ok_text={drawer_data.show_create_downtime ? (loaders.downtime_updating ? "Creating" : "Create") : (loaders.downtime_updating ? "Updating" : "Update")} loading={loaders.downtime_updating} handleCancelClick={this.closeDrawer} handleOkClick={this.createAndUpdateDowntime} capsule_button />
                  </div>
                </div>
              </ErrorBoundary>
            }
          </Drawer>
        </div>
      );
    } else if (!loaders.downtime_loading && !loaders.downtime_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load downtime list. please check your internet connection and reload the page." height={150} width={150} />
      );
    } else return null;
  }
}

const mapStateToProps = state => {
  return {
    downtime_details: state.downtime_details,
    screen_width: state.page_details.device_data.screen_width,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, downtimeActions), dispatch)
  }
}

Downtime.propTypes = {
  actions: PropTypes.object,
  downtime_details: PropTypes.object,
  screen_width: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(Downtime)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/downtime/index.js